import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Creators as NewspaperCreators } from '../../store/ducks/newspaper';
import NewspapersList from '../../components/NewspapersList';
import MenuStates from '../../components/MenuStates';
import { siteParams } from '../../config/site';
import Loading from '../../components/Loading';
import { Link, LinkExternal } from '../../assets/styles/components';

class Newspaper extends Component {
  static propTypes = {
    getNewspaperRequest: PropTypes.func.isRequired,
  };

  componentWillMount() {
    this.props.getNewspaperRequest(this.props.match.params.id);
  }

  getTitle = () => {
    var title = '';
    for (const key in this.props.states) {
      if (this.props.states[key].uf === this.props.newspaper.newspaper.uf.toUpperCase()) {
        var title = ` ${this.props.states[key].state}`;
      }
    }
    return title;
  };

  buildImageNewspaper = () => {
    var imageNewspaper = this.props.newspaper.newspaper.edition.images.original;
    if (this.props.match.params.edition_id) {
      const news = this.props.newspaper.editions.filter(elem => parseInt(this.props.match.params.edition_id) === elem.edition.id);
      if (news[0]) {
        var imageNewspaper = news[0].edition.images.original;
      }
    }
    return (
      <img
        src={imageNewspaper}
        alt={this.props.newspaper.newspaper.name}
        title={this.props.newspaper.newspaper.name}
        className="img-fluid mx-auto d-block"
      />
    );
  };

  buildPublicationDate = () => {
    if (this.props.match.params.edition_id) {
      const news = this.props.newspaper.editions.filter(elem => parseInt(this.props.match.params.edition_id) === elem.edition.id);
      if (news[0]) {
        return this.dateBr(news[0].edition.publicated_at);
      }
    }
    return this.dateBr(this.props.newspaper.newspaper.edition.publicated_at);
  };

  dateBr = (publicatedAt) => {
    const dt = publicatedAt.substring(0, 10).split('-');
    return `${dt[2]}/${dt[1]}/${dt[0]}`;
  };

  render() {
    if (this.props.newspaper.loading) {
      return <Loading />;
    }

    if (this.props.newspaper.newspaper.edition) {
      return (
        <Fragment>
          <div className="row main-newspaper">
            <div className="col-md-2">
              <MenuStates />
            </div>
            <div className="col-md-10">
              <h1 className="border-bottom-gray">
                <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Jornais</span>
                <span style={{ color: '#666' }}>{this.getTitle()}</span>
              </h1>

              <div className="row" style={{ marginTop: '15px' }}>
                <div className="col-md-4">{this.buildImageNewspaper()}</div>
                <div className="col-md-5 text-center text-md-left">
                  <h1 className="mt-4">{this.props.newspaper.newspaper.name}</h1>
                  <span>Data da publicação: {this.buildPublicationDate()}</span>
                </div>

                {(!this.props.user || !this.props.subscription.data.gateway) && (
                  <div className="col-md-3">
                    <div className="box-newspaper-assinar mt-4">
                      <h2>Assine e aproveite</h2>
                      <span className="valorSemanal">R$ 4,99</span>
                      <br />
                      <span>
                        por semana<br />ou R$ 14,99/mês
                      </span>
                      <br />
                      <LinkExternal
                        className="btn btn-secondary"
                        style={{ marginTop: '15px' }}
                        href={siteParams.assinatura.url}
                      >
                        ASSINE
                      </LinkExternal>
                      <p style={{ marginTop: '10px' }}>
                        <Link to="/signin">Já é assinante?</Link>
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <h3 className="border-bottom-gray">Últimas Edições</h3>
              <NewspapersList newspapers={this.props.editions} noTitle linkToEdition limit={12} />
            </div>
          </div>
        </Fragment>
      );
    }

    return <Loading />;
  }
}

const mapStateToProps = state => ({
  newspaper: state.newspaper,
  editions: state.newspaper.editions,
  states: state.states.states,
  user: state.user,
  subscription: state.subscription.subscription,
});

const mapDispatchToProps = dispatch => bindActionCreators(NewspaperCreators, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Newspaper));



// WEBPACK FOOTER //
// ./src/pages/newspaper/index.js